import { LoadingSpinner, Separator } from '@ais-ui/ui-core';

import { useLocalization } from '@ais-ui/locale-management';
import { HomeBookmark } from './HomeBookmark';
import { BookmarksAddEdit } from './BookmarksAddEdit';
import { BookmarksList } from './BookmarksList';
import { useGetBookmarks } from '@ais-ui/websockets';
import React, { useMemo } from 'react';
import { NoItemsEmptyStateList } from '../../../components/EmptyList';

export function SettingsBookmarksPage() {
  const { messages } = useLocalization();

  const { data, isLoading, isError } = useGetBookmarks();
  const bookmarks = useMemo(() => {
    if (data) {
      return data;
    }
    return [];
  }, [data]);

  return (
    <div className="space-y-6 w-full">
      <div>
        <h3 className="text-2xl font-medium">
          {messages.settingsBookmarksTitle}
        </h3>
        <p className="text-sm text-muted-foreground">
          {messages.settingsBookmarksSubtitle}
        </p>
      </div>
      <Separator className="w-full" />
      {isLoading && <LoadingSpinner></LoadingSpinner>}
      {isError && <div>ERROR</div>}
      {!isLoading && bookmarks.length === 0 && (
        <NoItemsEmptyStateList entity="bookmark" srcImage="empty_list_bro.png">
          <BookmarksAddEdit
            mode={'create'}
            className={'w-[80%] h-10'}
          ></BookmarksAddEdit>
        </NoItemsEmptyStateList>
      )}
      {!isLoading && bookmarks.length > 0 && (
        <div className="w-full space-y-4">
          <HomeBookmark bookmarks={bookmarks}></HomeBookmark>
          <div className="flex items-center justify-between pt-4">
            <h3 className="text-lg font-medium">
              {messages.settingsBookmarksListTitle}
            </h3>
            {!isLoading && bookmarks.length > 0 && (
              <BookmarksAddEdit mode="create"></BookmarksAddEdit>
            )}
          </div>
          <BookmarksList bookmarks={bookmarks} />
        </div>
      )}
    </div>
  );
}
